export const AGORA_APP_ID = '2c6c56c15db64b55a1e5d57d89c2ff6a'; // set your app id here